
/**
 * 郵便番号から住所自動入力
 */
jQuery(function () {
    $('#zipcode').jpostal({
        click: '#auto-load-address',
        postcode: [
            '#zipcode'
        ],
        address: {
            '#state_id': '%3',
            '#addr': '%4%5'
        }
    });
});